import { Nullable } from 'cng-common/models/utils'

interface IGetFormattedPercent {
  percent: Nullable<number> | undefined
  hasValueSign?: boolean
  // TODO: use pt instead of pp
  ending?: '%' | 'pp' | 'pt'
}

export const getFormattedPercent = ({
  percent,
  hasValueSign = false,
  ending = '%',
}: IGetFormattedPercent) => {
  if (percent === null || percent === undefined) {
    return '-'
  }

  let sign = ''
  if (hasValueSign) {
    sign = percent > 0 ? '+' : ''
  }

  return `${sign}${percent.toFixed(1)}${ending}`
}
